import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {validationsList_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {goalEdit_template} from "../components/templates/goalEdit_template";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class goal_edit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected goalsEditTemplate: goalEdit_template;
    protected validationsList: validationsList_template;

    protected getModuleName(){
        return "goal_edit";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        // create the users form
        this.goalsEditTemplate = new goalEdit_template("goalsEditTemplate", this.viewModel, this);

        return [this.validationsList.build(), this.goalsEditTemplate.build()];
    }

    protected isSaveAndStay(): boolean {
        return this.goalsEditTemplate.getSaveAndStay();
    }

    //
    // fill the template page with data.
    fillPage() : void{
        this.getFormData();
    }


    protected saveEditGoal(): void {

        this.save();
    }

    protected cancelEditGoal(){

        // redirect to goals list page
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Goal action canceled !");

        page.redirect('/goals');
    }

    protected getIdGoalRedirection(): number {
        return  this.goalsEditTemplate.getIdGoalRedirection();
    }


    protected isGoalRedirection(): boolean {
        return  this.goalsEditTemplate.isGoalRedirection();
    }

    //
    // getting data from server by ajax call.
    public getFormData(): void {

        this.loadingIn(this.goalsEditTemplate.builtTemplate.children.namedItem("goals-results"));
        this.loadingIn(this.goalsEditTemplate.builtTemplate.children.namedItem("view-results"));
        let id: number;

        if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.goalsEditTemplate.getTemplateViewModel().idGoal(id);
        } else {
            id = 0;
        }

        let usrReq_url: string = '/api/goals/get/' + id + "/";
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetGoalDataReturn;
        this.XHRHdl.execute();
    }

    //
    // Handling response data
    protected onGetGoalDataReturn(req, obj: goal_edit): Function {

        return function () {
            obj.manageResponse(req, obj,  () => {
                let response = JSON.parse(req.request.response);
                obj.setGoal(response);
                obj.getReferences();
                obj.setYearMonth(response.year, response.displayMonth);

                obj.loadingOut(obj.goalsEditTemplate.builtTemplate.children.namedItem("view-results"));
            });
        }
    }

    public setGoal(goal) : void {
        this.goalsEditTemplate.setGoal(goal);
    }

    public setYearMonth(year: number, month: string): void {
        this.goalsEditTemplate.setYearMonth(year, month);
    }
    protected getReferences(): void {

        let usrReq_url: string = '/api/goals/references/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReferencesDataReturn;
        this.XHRHdl.execute();
    }


    private onGetReferencesDataReturn(req, obj: goal_edit): Function {
        return function () {
            obj.manageResponse(req, obj, () => {

                let response = JSON.parse(req.request.response);
                obj.updateReferences(response);
                obj.getEditReferences();

                obj.loadingOut(obj.goalsEditTemplate.builtTemplate.children.namedItem("view-results"));
            });
        }
    }


    protected updateReferences(data): void {

        this.goalsEditTemplate.setBrands(data.brands);
        this.goalsEditTemplate.setInitiatives(data.initiatives);
        this.goalsEditTemplate.setGroups(data.groups);
        this.goalsEditTemplate.setMonths(data.months);
    }

    protected getEditReferences(): void {


        this.loadingIn(this.goalsEditTemplate.builtTemplate.children.namedItem("goals-results"));

        let usrReq_url: string = '/api/goals/edit/references/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.goalsEditTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, formReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetEditReferencesDataReturn;
        this.XHRHdl.execute();
    }


    private onGetEditReferencesDataReturn(req, obj: goal_edit): Function {
        return function () {
            obj.manageResponse(req, obj, () => {

                let response = JSON.parse(req.request.response);

                obj.updateEditReferences(response);

                obj.loadingOut(obj.goalsEditTemplate.builtTemplate.children.namedItem("goals-results"));

            });
        }
    }

    protected updateEditReferences(data: Array<object>): void {

        data.forEach((goal) => {
            goal['isSelected'] = false;
        });

        this.goalsEditTemplate.setPastGoals(data);
    }

    protected save(): void {


        // this.loadingIn(this.goalsEditTemplate.builtTemplate.children.namedItem("view-results"));
        let formReq_url: string = '/api/goals/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.goalsEditTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onPostGoalData;
        XHRHdl.execute();
    }

    private onPostGoalData(req, obj): Function {
        return function() {

            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                obj.goalsEditTemplate.setGoalId(response.idGoal);

                // obj.loadingOut(obj.goalsEditTemplate.builtTemplate.children.namedItem("view-results"));
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Goal saved successfully !");

                obj.redirectToSavedGoal()

            });
        }
    }

    protected redirectToSelectedGoal(): void {

        page.redirect('/goals/edit/' + this.goalsEditTemplate.getIdGoalRedirection());
    }

    protected redirectToSavedGoal(): void {

        if (this.isSaveAndStay()) {

            page.redirect('/goals/edit/' + this.goalsEditTemplate.getGoalId());
        } else {

            page.redirect('/goals');
        }
    }

    filterDropdownOnChange(): void {

        this.goalsEditTemplate.setStateAsChanged();
        this.goalsEditTemplate.buildYearMonth();
        this.getEditReferences();
    }

    public notifyNotValidAutoFillField(autoFillFieldName){

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, autoFillFieldName + ' format is not valid!');
        this.getVnAppZone().showNotificationToModule();
    }

    public notifyNotValidLength(){

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_ERROR, 'Number of entries is unvalid!');
        this.getVnAppZone().showNotificationToModule();
    }


}



// WEBPACK FOOTER //
// ./js/modules/goal_edit.ts